import { message } from 'antd'
document.title='仓储系统'
message.config({
  top: '25%',
  duration: 2,
  maxCount: 3
})
